import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon, CheckIcon, CreditCardIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { bonuses, includedExtras, includedTomos, prices, purchaseUrl } from '../data/content';
import { Countdown } from './ui/Countdown';
import { Mark } from './ui/Section';
export function Pricing({
  id = 'pricing'
}: {
  id?: string;
}) {
  return <section id={id} className="scroll-mt-24 bg-sky-50 px-4 py-14 md:py-16" aria-labelledby={`${id}-title`} data-id="element-254" data-mp="fd4ak73ib0ca">
      <div className="mx-auto max-w-2xl text-center" data-id="element-255" data-mp="k8taibjfuj94">
        <p className="text-[11px] font-extrabold uppercase tracking-[.16em] text-sky-800 md:text-sm" data-id="element-256" data-mp="6a34u7ijzb95">
          ⏰ Precio de lanzamiento — cierra en:
        </p>
        <div className="mt-4" data-id="element-257" data-mp="2r1de8a5kmfzp">
          <Countdown data-id="element-258" data-mp="2r13u3377j31x" />
        </div>
        <p className="mt-4 inline-flex items-center gap-2 rounded-full border border-red-200 bg-red-50 px-4 py-2 text-xs font-extrabold text-red-600" data-id="element-259" data-mp="2r02a2987r682">
          <AlertTriangleIcon className="h-4 w-4" data-id="element-260" data-mp="2fn2qhodfph5d" />
          Después pasa a {prices.after} ARS.
        </p>

        <article className="mt-8 rounded-3xl border-4 border-dashed border-sky-600 bg-white p-6 text-left shadow-2xl shadow-slate-900/15 md:p-9" data-id="element-261" data-mp="2apaykucshv16">
          <div className="text-center" data-id="element-262" data-mp="2om68ep0v7qia">
            <span className="inline-flex rounded-full bg-slate-900 px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-wide text-white" data-id="element-263" data-mp="2km5tl39utdap">
              📊 Todo lo que recibís hoy
            </span>
            <h2 id={`${id}-title`} className="mt-4 text-xl font-black uppercase text-slate-900 md:text-3xl" data-id="element-264" data-mp="2to5brywlunf8">
              5 tomos principales + 5 bonos gratis
            </h2>
          </div>

          <ul className="mt-6 space-y-2 border-t border-slate-200 pt-5" data-id="element-265" data-mp="33cn9g79l8een">
            {includedTomos.map(item => <li key={item} className="flex items-start gap-2 text-sm font-bold text-slate-800" data-id="element-266" data-mp="3hdzlw8pjhxvs">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-sky-600" data-id="element-267" data-mp="3cewg2m1qjnmr" />
                {item}
              </li>)}
          </ul>

          <p className="mt-6 text-sm font-black uppercase text-sky-700" data-id="element-268" data-mp="29ym7uh5et4p1">+ 5 bonos gratis hoy</p>
          <ul className="mt-2 space-y-2" data-id="element-269" data-mp="2ex5u6inx0ihx">
            {bonuses.map(bonus => <li key={bonus.number} className="flex flex-wrap items-baseline gap-x-2 text-sm font-bold text-slate-800" data-id="element-270" data-mp="2izu5cx03q1i2">
                <span data-id="element-271" data-mp="2spviitqx1zi7">
                  🎁 Bono {Number(bonus.number)} — {bonus.name}
                </span>
                <span className="ml-auto whitespace-nowrap text-xs" data-id="element-272" data-mp="2xoq76cbkeia8">
                  <s className="text-slate-400" data-id="element-273" data-mp="32ol34ua75y25">{bonus.value} ARS</s> →{' '}
                  <b className="text-sky-700" data-id="element-274" data-mp="36qpq5a653wft">GRATIS HOY</b>
                </span>
              </li>)}
          </ul>
          <p className="mt-4 text-center text-sm font-black uppercase text-slate-900" data-id="element-275" data-mp="18bv6i4sg2ar2">
            <s className="text-slate-400" data-id="element-276" data-mp="1cc5a5asrkp2r">{prices.bonusTotal} ARS en bonos</s>{' '}
            <Mark data-id="element-277" data-mp="14t5thcwotbn3">incluidos gratis hoy</Mark>
          </p>

          <p className="mt-6 border-t border-slate-200 pt-5 text-sm font-black uppercase text-slate-900" data-id="element-278" data-mp="14uqmuz79mojd">
            Y además recibís:
          </p>
          <ul className="mt-3 grid gap-x-4 gap-y-1.5 sm:grid-cols-2" data-id="element-279" data-mp="v330hcpkfxor">
            {includedExtras.map(item => <li key={item} className="flex items-start gap-2 text-sm font-semibold text-slate-700" data-id="element-280" data-mp="r2k8ninoarmk">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-sky-600" data-id="element-281" data-mp="1ns9x265gmd7d" />
                {item}
              </li>)}
          </ul>

          <div className="mt-6 border-t border-slate-200 pt-6 text-center" data-id="element-282" data-mp="1iquh2si52wvu">
            <p className="text-[11px] font-extrabold uppercase tracking-wide text-slate-500" data-id="element-283" data-mp="1epsd5yda1wnj">
              Antes
            </p>
            <dl className="mx-auto mt-3 max-w-xs space-y-1.5 text-sm font-bold text-slate-600" data-id="element-284" data-mp="19ulbsx7hd41s">
              <div className="flex justify-between" data-id="element-285" data-mp="39tzfh75mmfz">
                <dt data-id="element-286" data-mp="3uholfh8rmmff">5 tomos principales</dt>
                <dd className="tabular-nums text-slate-900" data-id="element-287" data-mp="3uku9ct5nri9k">{prices.tomos} ARS</dd>
              </div>
              <div className="flex justify-between" data-id="element-288" data-mp="1m7ypvv52fiif">
                <dt data-id="element-289" data-mp="1r19xvzlm65bx">+ 5 bonos</dt>
                <dd className="tabular-nums text-slate-900" data-id="element-290" data-mp="1r2kwzm446owp">{prices.bonusTotal} ARS</dd>
              </div>
              <div className="flex justify-between border-t border-slate-200 pt-1.5 font-black uppercase text-slate-900" data-id="element-291" data-mp="1d7a8qrkdl21b">
                <dt data-id="element-292" data-mp="24zrg5hsr2pmg">Valor total</dt>
                <dd className="tabular-nums text-slate-400 line-through" data-id="element-293" data-mp="251knkzb6tdvi">{prices.before} ARS</dd>
              </div>
            </dl>
            <p className="mt-4 text-sm font-bold text-slate-700" data-id="element-294" data-mp="29x009nxgl3qc">
              Hoy, precio promocional: <b className="text-sky-700" data-id="element-295" data-mp="1w1p9almc52r9">{prices.today} ARS</b>
            </p>
            <p className="mt-2 inline-flex rounded-full bg-yellow-300 px-3 py-1 text-xs font-extrabold uppercase tracking-wide text-slate-900" data-id="element-296" data-mp="20x4ih09eeahc">
              Ahorrás {prices.savings} ARS · {prices.discount} de descuento
            </p>
            <div className="mt-6" data-id="element-297" data-mp="h2i96k8vfddb">
              <motion.a href={purchaseUrl} target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.012
            }} whileTap={{
              scale: 0.988
            }} transition={{
              duration: 0.14,
              ease: [0.23, 1, 0.32, 1]
            }} className="flex w-full flex-col items-center gap-1 rounded-2xl border-b-4 border-sky-800 bg-sky-600 px-6 py-5 text-center shadow-xl shadow-sky-600/30 transition-colors duration-150 ease-out hover:bg-sky-700 focus:outline-none focus:ring-4 focus:ring-sky-600/30" data-id="element-298" data-mp="h1qoi4gtb01t">
                <span className="text-[11px] font-extrabold uppercase tracking-[.16em] text-white" data-id="element-299" data-mp="823lxfccjo76">
                  Hoy · precio promocional
                </span>
                <span className="text-4xl font-black leading-none text-white md:text-5xl" data-id="element-300" data-mp="39ag0o5569ti">
                  {prices.today} ARS
                </span>
                <span className="mt-1 text-sm font-extrabold uppercase tracking-wide text-white md:text-base" data-id="element-301" data-mp="36qslioxfz4qr">
                  🔨 Acceder a Muebles Fáciles en Casa →
                </span>
              </motion.a>
            </div>
            <p className="mt-3 text-xs font-bold uppercase tracking-wide text-slate-600" data-id="element-302" data-mp="1flo367e4u21x">
              Una sola compra · Acceso de por vida
            </p>
            <div className="mt-5 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[11px] font-semibold text-slate-500" data-id="element-303" data-mp="1of13huej05y1">
              <span className="flex items-center gap-1" data-id="element-304" data-mp="rro1pxdfziwm">
                <LockIcon className="h-3.5 w-3.5 text-sky-600" data-id="element-305" data-mp="wo4skzc10bde" /> Pago 100% seguro
              </span>
              <span className="flex items-center gap-1" data-id="element-306" data-mp="10q8cmccrgoaa">
                <ZapIcon className="h-3.5 w-3.5 text-sky-600" data-id="element-307" data-mp="10sujsavqp1rz" /> Acceso digital inmediato
              </span>
              <span className="flex items-center gap-1" data-id="element-308" data-mp="2c5ompbtw6hzw">
                <ShieldCheckIcon className="h-3.5 w-3.5 text-sky-600" data-id="element-309" data-mp="2c554rv48rtlv" /> Garantía de 7 días
              </span>
              <span className="flex items-center gap-1" data-id="element-310" data-mp="2h2x0z1bx61vv">
                <CreditCardIcon className="h-3.5 w-3.5 text-sky-600" data-id="element-311" data-mp="2r8ya7gzz8vvy" /> Mercado Pago · Tarjeta ·
                Transferencia
              </span>
            </div>
          </div>
        </article>
      </div>
    </section>;
}